module.exports = __webpack_public_path__ + "img/index-slider-2.bc1155f5.svg";